import styled from 'styled-components';

import Button from 'components/common/button';
import { H3 } from 'components/common/headers';
import Input from 'components/common/input';
import InsetContainer from 'components/common/containers/inset_container';
import StackContainer from 'components/common/containers/stack_container';
import TrashIcon from 'components/lib/icons/trash_icon';
import InlineContainer from 'components/common/containers/inline_container';

const rightColumnWidth = 500;

export const DeleteTeamIcon = styled(TrashIcon)`
  cursor: pointer;
  fill: none;
  height: 24px;
  stroke: ${p => p.theme.colors.black};
  vertical-align: bottom;
  width: 16px;
  &.disabled {
    stroke: ${p => p.theme.colors.gray400};
    &:hover {
      cursor: not-allowed;
      stroke: ${p => p.theme.colors.gray400};
    }
  }
  &:hover {
    stroke: ${p => p.theme.colors.red500};
  }
`;

export const PendingSpinnerWrapper = styled.div`
  height: auto;
  position: static;
`;

export const DescriptionTextArea = styled.textarea`
  border-radius: ${p => p.theme.borderRadius.default};
  border: solid 1px ${p => p.theme.colors.gray300};
  flex-grow: 1;
  float: right;
  &:focus {
    border-color: ${p => p.theme.colors.green500};
  }
  max-height: 100px;
  min-height: 70px;
  outline: none;
  padding: ${p => p.theme.spacing.insetSmall};
  resize: none;
`;

export const EditTeamHeader = styled(H3)`
  color: ${p => p.theme.colors.black};
  justify-content: flex-start;
`;
export const EditorHeader = styled(InsetContainer)`
  align-items: flex-start;
`;

export const EditTeamPage = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;

export const ErrorMessage = styled.span`
  color: ${p => p.theme.colors.red500};
  font-size: ${p => p.theme.fontSize.base};
  margin-left: ${p => p.theme.spacing.medium};
  padding-top: ${p => p.theme.spacing.medium};
`;

export const InputField = styled(Input)`
  border-radius: ${p => p.theme.borderRadius.default};
  border: solid 1px ${p => p.theme.colors.gray300};
  &:focus {
    border-color: ${p => p.theme.colors.green500};
  }
  min-height: ${p => p.theme.spacing.insetLarge};
  padding: ${p => p.theme.spacing.insetSmall};
  width: 100%;
  &.teamEditor-inputField-error {
    border-color: ${p => p.theme.colors.red500};
  }
`;

export const InputFieldWrapper = styled(StackContainer).attrs({ inset: 'none', stack: 'large' })`
  display: inline-flex;
  flex-direction: row;
  width: 100%;
`;

export const SearchInputWrapper = styled(StackContainer).attrs({ inset: 'none' })`
  width: 340px;
`;

export const TeamCreator = styled.div`
  font-size: ${p => p.theme.fontSize.base};
`;

export const TeamEditorFooter = styled(InlineContainer)`
  background-color: ${p => p.theme.colors.white};
  border-top: 1px solid ${p => p.theme.colors.gray300};
  width: ${rightColumnWidth}px;
  justify-content: flex-end;
`;

export const TeamEditorLabel = styled.label`
  font-weight: ${p => p.theme.fontWeight.heavy};
  flex-basis: 20%;
  flex-shrink: 0;
`;

export const TeamEditorSaveButton = styled(Button)`
  min-width: 64px;
`;

export const TeamInfo = styled.div`
  border-left: 1px solid ${p => p.theme.colors.gray300};
  min-width: ${rightColumnWidth}px;
  width: ${rightColumnWidth}px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const TeamForm = styled(InsetContainer)`
  flex: 1;
  flex-shrink: 0;
  overflow-y: auto;
`;

export const Users = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/team_editor/team_editor_components.jsx